import React from "react";
import styles from "./styles/AboutHero.module.css";
import heroBg from "../../../images/about-header.jpg";

export default function AboutHero() {
  return (
    <section className={styles.hero} style={{ backgroundImage: `url(${heroBg})` }}>
      <div className={styles.overlay} />
      <div className={styles.container}>
        <div className={styles.content}>
          <div className={styles.breadcrumb}>HOME</div>
          <h1 className={styles.title}>About us</h1>
          <p className={styles.description}>
            Alliance Automation is a leader in factory automation, robotics and special purpose
            machines in India with more than 20 years of knowledge and experience.
          </p>
        </div>
      </div>
    </section>
  );
}
